<div *ngIf="isCommonDataLoaded" >


  <form name="tableItemEditForm" #tableItemEditForm="ngForm">
    <!--<div class="row">
    <div class="col-sm-6">
      isDisabledByNif():{{isDisabledByNif()}}
    </div>
    <div class="col-sm-6">
      isDisabledByNifColetivo():{{isDisabledByNifColetivo()}}
    </div>

  </div>
  <div class="row">
    <div class="col-sm-6">
      isDisabledByNif():{{isDisabledByNif()}}
    </div>
    <div class="col-sm-6">
      isDisabledByNifColetivo():{{isDisabledByNifColetivo()}}
    </div>

  </div>-->
    <fieldset [disabled]="isDeferida == true || item.notEditable == true  || isAIndeferir == true">

      <div class="row">
        <!--NIF-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset [disabled]="!(isFuneraryOrService)">
              <label for="NIF" [class.disabled]="!(isFuneraryOrService)">
                <span *ngIf="isFuneraryOrService" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NIF' | translate}}
              </label>
              <input class="form-control"
                     (blur)="onNifBlur()"
                     type="number"
                     numeric="9"
                     [(ngModel)]="item.NIF"
                     name="NIF"
                     #NIF="ngModel"
                     maxlength="9"
                     nifValidation
                     [required]="item.hasLegalRepresentation?.toString()== 'false' || (isFuneraryOrService?.toString()=='true')" />
              <validation-message [control]="NIF"></validation-message>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row">
        <!--Nome-->
        <div class="col-sm-8">
          <div class="form-group ">
            <fieldset [disabled]="(isFieldDisabled('name') && isFuneraryOrService?.toString()=='false' && estadoRegistado(item.stateRL)) || isDisabledByNif()  ">
              <label for="name" [class.disabled]="isFieldDisabled('name') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)">
                <span class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Name' | translate}}
              </label>
              <div class="position-relative">
                <input class="form-control input-right"
                       type="text"
                       [(ngModel)]="item.beneficiaryName"
                       #name="ngModel"
                       maxlength="60"
                       required
                       name="name"
                       messageFieldType="string">
                <validation-message [control]="name"></validation-message>
              </div>
            </fieldset>
          </div>
        </div>

        <!--Data de Nascimento-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset [disabled]="(isFieldDisabled('dateOfBirth') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)) || isDisabledByNif() || isDisabledByNifColetivo()">
              <label for="dateOfBirth" [class.disabled]="isFieldDisabled('dateOfBirth') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)">
                <span *ngIf="!isDisabledByNifColetivo()" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.DateOfBirth' | translate}}
              </label>
              <div class="form-row">
                <div class="input-group col-sm-12">
                  <input #dpDateOfBirth="bsDatepicker"
                         bsDatepicker
                         type="text"
                         autocomplete="off"
                         placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                         class="form-control DatepickerCustomClasse"
                         [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                         [(ngModel)]="item.dateOfBirth"
                         name="dateOfBirth"
                         [minDate]="minDate"
                         [required]="!isDisabledByNifColetivo()"
                         [maxDate]="maxDate"
                         maxlength="10"
                         (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDateOfBirth)"
                         #dateOfBirth="ngModel" />
                  <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
                    <span class="input-group-text" id="basic-addon2">
                      <i class="icon-calendar"></i>
                    </span>
                  </div>
                  <validation-message [control]="dateOfBirth"></validation-message>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <div class="row">
        <!--Genero-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset [disabled]="(isFieldDisabled('gender') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL))  || isDisabledByNif() || isDisabledByNifColetivo()">
              <label for="Gender" [class.disabled]="(isFieldDisabled('gender') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL))  || isDisabledByNif() || isDisabledByNifColetivo()">
                <span *ngIf="!isDisabledByNifColetivo()" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Gender' | translate}}
              </label>
              <select class="custom-select"
                      [(ngModel)]="item.gender"
                      name="gender"
                      #gender="ngModel"
                      [required]="!isDisabledByNifColetivo()"
                      [dropdownTitle]="{value : item.gender, dimensions :  genders }"
                      nullableSelect>
                <default-dropdown-values></default-dropdown-values>
                <option *ngFor="let domain of genders" [value]="domain.code">
                  {{domain.description}}
                </option>
              </select>
              <validation-message [control]="gender"></validation-message>
            </fieldset>
          </div>
        </div>

        <!--Estado civil na data do óbito-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset [disabled]="(isFieldDisabled('civilStateDeathDate') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)) || isDisabledByNif() || isDisabledByNifColetivo()">
              <label for="MaritalStatus" [class.disabled]="(isFieldDisabled('civilStateDeathDate') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)) || isDisabledByNif() || isDisabledByNifColetivo()">
                <span *ngIf="!isDisabledByNifColetivo()" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.CivilState' | translate}}
              </label>
              <select class="custom-select"
                      [(ngModel)]="item.civilStateDeathDate"
                      name="civilStateDeathDate"
                      #civilStateDeathDate="ngModel"
                      [required]="!isDisabledByNifColetivo()"
                      nullableSelect>
                <default-dropdown-values></default-dropdown-values>
                <option *ngFor="let domain of maritalStatus" [value]="domain.description">
                  {{domain.value}}
                </option>
              </select>
              <validation-message [control]="civilStateDeathDate"></validation-message>
            </fieldset>
          </div>
        </div>

        <!--Tem Nacionalidade Portuguesa-->
        <div class="col-sm-4">
          <div class="form-group">
            <fieldset [disabled]="(isFieldDisabled('hasNacPT') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)) || isDisabledByNif()  || isDisabledByNifColetivo() || isDisabledByRL()">
              <label for="hasPortugueseNationality" [class.disabled]="(isFieldDisabled('hasNacPT') && isFuneraryOrService?.toString()=='false') || isDisabledByNif()  || isDisabledByNifColetivo()">
                <span *ngIf="!isDisabledByNifColetivo()" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
                {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.HasPortugueseNationality' | translate}}
              </label>
              <div class="btn-group btn-group-toggle maxWidth">
                <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle" [class.active]="domain.value==item.hasNacPT?.toString()" [radioLabel]="hasPortugueseNationality">
                  <input type="radio"
                         [(ngModel)]="item.hasNacPT"
                         (change)="hasPortugueseNationalityChange(item.hasNacPT)"
                         [clearRelated]="{model : this.item , propsToReset : ['identificationNumberFirst','identificationNumberLast']}"
                         [required]="!isDisabledByNifColetivo()"
                         name="hasPortugueseNationality"
                         #hasLegalRepresentation="ngModel"
                         [value]="domain.value" tabindex="0">
                  {{domain.description}}
                </label>
                <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
              </div>
            </fieldset>
          </div>
        </div>

      </div>




    </fieldset>


    <div class="row">
      <!--Tipo de documento de identificação-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="(isFieldDisabled('identificationDocumentType') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)) || (item.hasNacPT!= null && item.hasNacPT!=undefined) || isDisabledByNif()  || isDisabledByNifColetivo()  || item.notEditable == true  || isAIndeferir == true  || isDeferida == true ">
            <label for="DocumentType" [class.disabled]="(isFieldDisabled('identificationDocumentType') && isFuneraryOrService?.toString()=='false'  && estadoRegistado(item.stateRL)) || (item.hasNacPT!= null && item.hasNacPT!=undefined) || isDisabledByNif()  || isDisabledByNifColetivo()  || item.notEditable == true  || isAIndeferir == true || isDeferida == true ">
              <span *ngIf="!isDisabledByNifColetivo()" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationDocumentType' | translate}}
            </label>
            <select class="custom-select"
                    [(ngModel)]="item.identificationDocumentType"
                    [required]="!isDisabledByNifColetivo()"
                    name="identificationDocumentType"
                    #identificationDocumentType="ngModel"
                    [dropdownTitle]="{value : item.identificationDocumentType, dimensions : documentTypes }"
                    nullableSelect>
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let domain of documentTypes" [value]="domain.code">
                {{domain.description}}
              </option>
            </select>
            <validation-message [control]="identificationDocumentType"></validation-message>
          </fieldset>
        </div>
      </div>

      <!--Número de identificação-->
      <div class="col-sm-4">
        <div class="form-group">
          <fieldset [disabled]="(isNICDisable() && estadoRegistado(item.stateRL)) || item.notEditable ">
            <label for="identificationNumber" [class.disabled]="(isNICDisable() && estadoRegistado(item.stateRL)) || item.notEditable ">
              <span *ngIf="!isDisabledByNifColetivo()" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationNumber' | translate}}
            </label>
            <div class="form-row">
              @if(item.identificationDocumentType !='P' ){
              <div class="col-sm-9">
                <input class="form-control"
                       type="text"
                       [required]="!isDisabledByNifColetivo()"
                       numeric="8"
                       [(ngModel)]="item.identificationNumberFirst"
                       name="identificationNumberFirst"
                       #identificationNumberFirst="ngModel"
                       maxlength="8" />
              </div>
              } @else {
              <div class="col-sm-9">
                <input class="form-control"
                       type="text"
                       mask="A*"
                       [required]="!isDisabledByNifColetivo()"
                       [(ngModel)]="item.identificationNumberFirst"
                       name="identificationNumberFirst"
                       #identificationNumberFirst="ngModel"
                       maxlength="10" />
              </div>
              }
              <div class="col-sm-3">
                <input class="form-control"
                       type="text"
                       maxlength="4"
                       [(ngModel)]="item.identificationNumberLast"
                       name="identificationNumberLast"
                       #identificationNumberLast="ngModel" />
              </div>
            </div>
            <validation-message [control]="identificationNumberFirst"></validation-message>
          </fieldset>
        </div>
      </div>

      <!--Tipologia de representação-->
      <div class="col-sm-4" *ngIf="showLegalRepresentationTipology()">
        <div class="form-group">
          <fieldset disabled>
            <label for="scholarSituationDeathDate">
              <span *ngIf="(hasLegalRepresentation?.toString() == 'true'   && (item.beneficiaryID!=1)  && estadoRegistado(item.stateRL)) || isDisabledByNif()  || isDisabledByNifColetivo() || isDeferida == true || item.notEditable == true  || isAIndeferir == true" class="mandatory" [style.color]="estadoPendente?'#9F9F9F':'#DB3347'">*</span>
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.RepresentationType' | translate}}
            </label>
            <select class="custom-select"
                    [(ngModel)]="item.representationType"
                    name="representationType"
                    #representationType="ngModel"
                    [dropdownTitle]="{value : item.representationType, dimensions :  typesRepresentation }"
                    nullableSelect
                    [required]="hasLegalRepresentation?.toString() == 'true'  && item.beneficiaryID!=1">
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let domain of dropListRepresentationType" [value]="domain.value">
                {{domain.description}}
              </option>
            </select>
            <validation-message [control]="representationType"></validation-message>
          </fieldset>
        </div>
      </div>

    </div>


    <div class="row">
      <!--Motivo de rejeição da representação legal-->
      <div class="col-sm-12" *ngIf="item.rejectionReason != null && item.rejectionReason != undefined  && isAIndeferir == false">
        <div class="form-group">
          <fieldset>
            <label for="rejectionReason" class="form-control-disabled">
              {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.LegalRepresentationIdentification.Fields.RejectionReason' | translate}}
            </label>
            <textarea class="form-control input-right form-control-disabled" rows="3" type="text" [(ngModel)]="item.rejectionReason"
                      [maxLength]="1024"
                      readonly
                      #rejectionReason="ngModel" name="rejectionReason"
                      messageFieldType="string"></textarea>
            <validation-message [control]="rejectionReason"></validation-message>
          </fieldset>
        </div>
      </div>
    </div>

    <fieldset [disabled]="isDeferida == true || item.notEditable == true">
      <!--Beneficio requerido-->
      <div class="row">
        <div class="col-12">
          <div class="form-group text-secondary ft-sz-15">
            <label for="Campos obrigatórios"
                   [style.color]="(isRepresentado===true || isBenefitDisabled() || estadoPendente || isDeferida == true || item.notEditable == true)?'#9F9F9F':'#545454'">
              <span [style.color]="(isRepresentado===true || isBenefitDisabled() || estadoPendente || isDeferida == true || item.notEditable == true )?'#9F9F9F':'#DB3347'" class="mandatory">*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.BenefitMandatory' | translate}}
            </label>
          </div>
        </div>
      </div>

      <fieldset [disabled]="isRepresentado===true">
        <!--Pensão de sobrevivência -->
        <div class="row">
          <div class="col-sm-12 ml-2">
            <div class="form-check mb-4">
              <fieldset>
                <input class="form-check-input"
                       aria-controls="collapseManual"
                       type="checkbox"
                       [(ngModel)]="item.survivalPensionBenefit"
                       name="survivalPensionBenefit"
                       #survivalPensionBenefit="ngModel"
                       id="PensaoSobreviviencia"
                       (change)="isSurvivalPensionBenefitChanged($event.target.checked)"
                       [disabled]="isBenefitDisabled()"
                       [checked]="item?.survivalPensionBenefit?.toString()=='true'">
                <label class="form-check-label align-items-center " for="PensaoSobreviviencia">
                  {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.SurvivalPensionBenefit' | translate}}
                  <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleSurvivalPensionBenefit ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation(); toggleVisibilitySurvivalPensionBenefit();"></span>
                </label>
                <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleSurvivalPensionBenefit" style="text-align: justify;">
                  <br />
                  <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.SurvivalPensionBenefitTooltip' | translate}}</span>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <!--Reembolso de despesas de funeral -->
        <div class="row">
          <div class="col-sm-12 ml-2">
            <div class="form-check mb-4">
              <fieldset>
                <input class="form-check-input"
                       aria-controls="collapseManual"
                       type="checkbox"
                       [(ngModel)]="item.reimbursementFuneralBenefit"
                       name="reimbursementFuneralBenefit"
                       #reimbursementFuneralBenefit="ngModel"
                       id="ReembolsoDespesasFuneral"
                       (change)="isReimbursementFuneralBenefitChanged($event.target.checked)"
                       [disabled]="isBenefitDisabled()"
                       [checked]="item?.reimbursementFuneralBenefit?.toString()=='true' ">
                <label class="form-check-label align-items-center " for="ReembolsoDespesasFuneral">
                  {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.ReimbursementFuneralBenefit' | translate}}
                  <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleReimbursementFuneralBenefit ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation(); toggleVisibilityReimbursementFuneralBenefit()"></span>
                </label>
                <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleReimbursementFuneralBenefit" style="text-align: justify;">
                  <br />
                  <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.ReimbursementFuneralBenefitTooltip' | translate}}</span>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <!--Subsídio de morte -->
        <div class="row">
          <div class="col-sm-12 ml-2">
            <div class="form-check mb-4">
              <fieldset>
                <input class="form-check-input"
                       aria-controls="collapseManual"
                       type="checkbox"
                       [(ngModel)]="item.funeralAllowanceBenefit"
                       name="funeralAllowanceBenefit"
                       #funeralAllowanceBenefit="ngModel"
                       id="SubsidioMorte"
                       (change)="isFuneralAllowanceBenefitChanged($event.target.checked)"
                       [disabled]="isBenefitDisabled()"
                       [checked]="item?.funeralAllowanceBenefit?.toString()=='true'">
                <label class="form-check-label align-items-center " for="SubsidioMorte">
                  {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.FuneralAllowanceBenefit' | translate}}
                  <span class="text-primary ml-1" aria-label="Tooltip com informação" [ngClass]="isVisibleFuneralAllowanceBenefit ? 'icon-minus' : 'icon-more'" (click)="$event.preventDefault(); $event.stopPropagation(); toggleVisibilityFuneralAllowanceBenefit()"></span>
                </label>
                <div class="pt-2 text-gray-600 mt-2 mb-5" *ngIf="isVisibleFuneralAllowanceBenefit" style="text-align: justify;">
                  <br />
                  <span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BenefitType.Fields.FuneralAllowanceBenefitTooltip' | translate}}</span>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </fieldset>
    </fieldset>
  </form>

  <div class="d-flex justify-content-between mt-4 mb-2">
    <button type="button" class="btn btn-outline-primary disable-on-fieldset" (click)="removeFromList(isEdit)" [disabled]="removeTrashButton()">
      <span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span>
    </button>
    <button [disabled]="!( tableItemEditForm.valid && isFormValid() ) "
            type="button" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)">
      <span class="icon-check"></span><span>Aplicar</span>
    </button>
  </div>
  <!--<span> tableItemEditForm.valid:{{ tableItemEditForm.valid}}</span>-->
</div>
